(() => {
  const markReady = component => {
    const slot = component?.closest('[data-bundle-loading]');
    if (slot) slot.setAttribute('data-bundle-ready', '');
  };
  document.addEventListener('kaching-bundles-block-loaded', event => markReady(event.detail?.component));
  const watch = root => {
    root.querySelectorAll('[data-bundle-loading]:not([data-bundle-ready])').forEach(slot => {
      const inspect = () => {
        const component = slot.querySelector('kaching-bundles-block');
        if (component?.querySelector('[role="button"], button') && component.getBoundingClientRect().height > 100) markReady(component);
        if (slot.hasAttribute('data-bundle-ready')) observer.disconnect();
      };
      const observer = new MutationObserver(inspect);
      observer.observe(slot, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-bundle-ready'] });
      inspect();
      setTimeout(() => {
        observer.disconnect();
        slot.setAttribute('data-bundle-ready', '');
      }, 15000);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => watch(document), { once: true });
  } else {
    watch(document);
  }
  document.addEventListener('shopify:section:load', event => watch(event.target));
})();
